export default function useSearchParam(location) {
  return new URLSearchParams(location.search);
}